const UserIcon = ({ color, size }: { color: string; size: string }) => (
  <svg width={size || '20'} height={size || '20'} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.16669 16.6667V15.8333C4.16669 12.6117 6.77836 10 10 10V10C13.2217 10 15.8334 12.6117 15.8334 15.8333V16.6667"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10C11.841 10 13.3334 8.50766 13.3334 6.66671C13.3334 4.82576 11.841 3.33337 10 3.33337C8.15907 3.33337 6.66669 4.82576 6.66669 6.66671C6.66669 8.50766 8.15907 10 10 10Z"
      stroke={color || 'currentColor'}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserIcon;
